import { createContext, useContext } from 'react';

import {
  Accounts,
  AgeDemographicTargetables,
  APIKeys,
  Billables,
  Bills,
  BlackbaudRaisersEdgeIntegrations,
  ContactLists,
  CustomFields,
  DataRequests,
  Domains,
  DonationForms,
  EmailSendRequests,
  EmailUsageRecords,
  EmailVerifications,
  Events,
  FacebookCampaignIntegrations,
  FacebookPages,
  Fonts,
  Forms,
  Fundraisers,
  GeoFilters,
  GoogleAdsAdGroups,
  GoogleAdsCustomers,
  GrowthCreditEntries,
  ImisIntegrations,
  Importers,
  InterestTargetables,
  MetaIntegrations,
  Notifications,
  OnboardingTasks,
  PartnerExports,
  Paths,
  Recommendations,
  RedirectDomains,
  SegmentExportRecipients,
  SegmentExports,
  Tags,
  Targetables,
  UsageMetrics,
  UsageQuotas,
  UsageReports,
  UserNotifications,
  UserRoles,
  Users,
} from '@feathr/blackbox';

import { ReportStore } from './useReportStore';

export class AuthenticatedStore extends ReportStore {
  public Accounts = new Accounts([]);

  public APIKeys = new APIKeys([]);

  public Billables = new Billables([]);

  public Bills = new Bills([]);

  public BlackbaudRaisersEdgeIntegrations = new BlackbaudRaisersEdgeIntegrations([]);

  public ContactLists = new ContactLists([]);

  public CustomFields = new CustomFields([]);

  public DataRequests = new DataRequests([]);

  public Domains = new Domains([]);

  public DonationForms = new DonationForms([]);

  // Partner dashboard email sends
  public EmailSendRequests = new EmailSendRequests([]);

  public EmailVerifications = new EmailVerifications([]);

  public override Events = new Events([]);

  public ImisIntegrations = new ImisIntegrations([]);

  public MetaIntegrations = new MetaIntegrations([]);

  public FacebookCampaignIntegrations = new FacebookCampaignIntegrations([]);

  public FacebookPages = new FacebookPages([]);

  public Fonts = new Fonts([]);

  public Forms = new Forms([]);

  public Fundraisers = new Fundraisers([]);

  public GeoFilters = new GeoFilters([]);

  public GoogleAdsAdGroups = new GoogleAdsAdGroups([]);

  public GoogleAdsCustomers = new GoogleAdsCustomers([]);

  public GrowthCreditEntries = new GrowthCreditEntries([]);

  public Importers = new Importers([]);

  public Notifications = new Notifications([]);

  public PartnerExports = new PartnerExports([]);

  public Paths = new Paths([]);

  public Recommendations = new Recommendations([]);

  public RedirectDomains = new RedirectDomains([]);

  public SegmentExportRecipients = new SegmentExportRecipients([]);

  public SegmentExports = new SegmentExports([]);

  public Tags = new Tags([]);

  public override Targetables = new Targetables([]);

  public AgeDemographicTargetables = new AgeDemographicTargetables([]);

  public InterestTargetables = new InterestTargetables([]);

  public UsageReports = new UsageReports([]);

  public UsageMetrics = new UsageMetrics([]);

  public UsageQuotas = new UsageQuotas([]);

  public UserNotifications: UserNotifications;

  public UserRoles = new UserRoles([]);

  public Users = new Users([]);

  public OnboardingTasks = new OnboardingTasks([]);

  public EmailUsageRecords = new EmailUsageRecords([]);

  public constructor() {
    super();

    this.UserNotifications = new UserNotifications([], {
      Notifications: this.Notifications,
    });
  }
}
export const AuthenticatedStoreContext = createContext<AuthenticatedStore | null>(null);

export function createAuthenticatedStore(): AuthenticatedStore {
  return new AuthenticatedStore();
}

function useAuthenticatedStore(): AuthenticatedStore {
  const context = useContext(AuthenticatedStoreContext);
  if (!context) {
    throw new Error('useAuthenticatedStore must be used within AuthenticatedStoreProvider');
  }
  return context;
}

export default useAuthenticatedStore;
